// src/config.ts

export const COMPANY_INFO = {
    name: "Bestune Cars Venezuela",
    whatsappNumber: "584242484359", // Solo números, sin símbolos
    email: "grupooficialbestune@gmail.com",
    instagramUrl: "https://www.instagram.com/bestune_cars/",
    tiktokUrl: "https://www.tiktok.com/@bestunevzla",
    facebookUrl: "https://www.facebook.com/profile.php?id=61572685456205",
    address: "Calle Sucre con Av. Guaicaipuro, Edf. Nro 60, Urb. Chacao, Caracas.",
    mapsUrl: "https://maps.app.goo.gl/pHGYShqQZu5Lu1xj7" // Puedes poner tu link real aquí
};

// Generador de Links de WhatsApp con mensaje
export const getWhatsappLink = (message: string = "") => {
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${COMPANY_INFO.whatsappNumber}?text=${encodedMessage}`;
};